import styled from "styled-components"

import { maxWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const AdContainer = styled.section`
  width: ${({ widthNonMobile }) => widthNonMobile}px;
  margin: 4rem auto;
  text-align: center;

  h5 {
    padding-bottom: 0.8rem;
    font-size: 1rem;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
    color: #454545;
  }

  ${maxWidth.mobile`
    width: ${({ widthMobile }) => widthMobile}px;
  `}
`

export const AdImage = styled(CloudinaryImage)`
  padding-bottom: calc(${({ aspectRatio }) => aspectRatio} * 100%);

  ${maxWidth.mobile`
    padding-bottom: calc(${({ aspectRatio }) => aspectRatio} * 100%);
  `}
`
